import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription, switchMap } from 'rxjs';
import { DetailService } from 'src/app/modules/pim-graphql/views/detail-view/detail-view/detail.service';
import { HeaderData } from 'src/app/modules/pim-graphql/views/shared-view.model';
import { RefreshService } from 'src/app/services/refresh.service';

@Component({
  selector: 'app-detail-package',
  templateUrl: './detail-package.component.html',
  styleUrls: ['./detail-package.component.scss'],
  standalone: false,
})
export class DetailPackageComponent implements OnInit, OnDestroy {
  private detailService = inject(DetailService);
  private route = inject(ActivatedRoute);
  private refreshService = inject(RefreshService);

  packageId!: string;
  headerData?: HeaderData;
  loading = true;
  private paramSubscription?: Subscription;

  ngOnInit(): void {
    this.paramSubscription = combineLatest([
      this.route.params,
      this.refreshService.refreshData$,
    ])
      .pipe(
        switchMap((values) => {
          this.packageId = values[0]['packageId'];
          this.headerData = undefined;
          this.loading = true;

          return this.detailService.getDetailHeader(this.packageId);
        }),
      )
      .subscribe((detailData) => {
        this.headerData = detailData;
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.paramSubscription?.unsubscribe();
  }
}
